webpackJsonp([915738553496],{

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Privacy = function Privacy() {
	  return _react2.default.createElement(
	    _layout.FrameContainer,
	    null,
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        '\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\xA0\u682A\u5F0F\u4F1A\u793Eabasaku(\u4EE5\u4E0B\u300C\u5F53\u793E\u300D\u3068\u3044\u3044\u307E\u3059)\u304C\u3001\u63D0\u4F9B\u3059\u308B\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u30B5\u30FC\u30D3\u30B9 \u300CFlick!On!TV\u300D\uFF08\u4EE5\u4E0B\u300C\u672C\u30B5\u30FC\u30D3\u30B9\u300D\u3068\u3044\u3044\u307E\u3059\uFF09\u306B\u304A\u3044\u3066\u304A\u5BA2\u69D8\uFF08\u4EE5\u4E0B\u300C\u30E6\u30FC\u30B6\u30FC\u300D \u3068\u3044\u3044\u307E\u3059\uFF09\u306B\u95A2\u3059\u308B\u60C5\u5831\u3092\u4EE5\u4E0B\u306E\u901A\u308A\u306B\u53D6\u308A\u6271\u3044\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C1\u6761\u3000\u7DCF\u5247'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1.\u5F53\u793E\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u4FDD\u8B77\u306E\u5B9F\u73FE\u306E\u70BA\u3001\u500B\u4EBA\u60C5\u5831\u4FDD\u8B77\u6CD5\u3001\u5404\u7701\u5E81\u30AC\u30A4\u30C9\u30E9\u30A4\u30F3\u305D\u306E\u4ED6\u95A2\u9054\u3059\u308B\u6CD5\u4EE4\u7B49\u3092\u9075\u5B88\u3044\u305F\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '2.Flick!On!TV\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC\uFF08\u4EE5\u4E0B\u300C\u672C\u30DD\u30EA\u30B7\u30FC\u300D\u3068\u3044\u3044\u307E\u3059\uFF09\u306F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\uFF08\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u4ED8\u968F\u3057\u3066\u5F53\u793E\u304C\u63D0\u4F9B\u3059\u308B\u30B5\u30FC\u30D3\u30B9\u3092\u542B\u307F\u307E\u3059\uFF09\u306E\u5229\u7528\u306B\u95A2\u3057\u3001\u9069\u7528\u3055\u308C\u307E\u3059\u3002 \u307E\u305F\u3001\u5F53\u793E\u904B\u5BAE\u306E\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u4E0A\u306B\u63B2\u8F09\u3059\u308B\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC\u305D\u306E\u4ED6\u306E\u500B\u4EBA\u60C5\u5831\u4FDD\u8B77\u65B9\u91DD\u53C8\u306FFlick!On!TV\u306B\u95A2\u3059\u308B\u5229\u7528\u898F\u7D04\u7B49\u306B\u304A\u3044\u3066\u3001\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u306E\u53D6\u6271\u3044\u3092\u898F\u5B9A\u3059\u308B\u5834\u5408\u3001\u5F53\u8A72\u898F\u5B9A\u3082\u9069\u7528\u3055\u308C\u308B\u3082\u306E\u3068\u3057\u3001\u5F53\u8A72\u898F\u5B9A\u7B49\u304C\u672C\u30DD\u30EA\u30B7\u30FC\u3068\u62B5\u89E6\u3059\u308B\u5834\u5408\u306B\u306F\u3001\u672C\u30DD\u30EA\u30B7\u30FC\u304C\u512A\u5148\u3055\u308C\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '3.\u63D0\u643A\u30D1\u30FC\u30C8\u30CA\u30FC\u306B\u3088\u308A\u63D0\u4F9B\u3055\u308C\u308B\u63D0\u643A\u30B5\u30FC\u30D3\u30B9\u305D\u306E\u4ED6\u5F53\u793E\u4EE5\u5916\u306E\u8005\u304C\u63D0\u4F9B\u3059\u308B\u30B5\u30FC\u30D3\u30B9\u306B\u3064\u3044\u3066\u306F\u3001\u672C\u30DD\u30EA\u30B7\u30FC\u306E\u898F\u5B9A\u306F\u9069\u7528\u3055\u308C\u307E\u305B\u3093\u3002\u3053\u308C\u3089\u306E\u30B5\u30FC\u30D3\u30B9\u306B\u304A\u3051\u308B\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u306E\u53D6\u6271\u3044\u306B\u3064\u3044\u3066\u306F\u3001\u5F53\u8A72\u5916\u90E8\u30B5\u30FC\u30D3\u30B9\u3092\u63D0\u4F9B\u3059\u308B\u4E8B\u696D\u8005\u304C\u5225\u9014\u5B9A\u3081\u308B\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC\u7B49\u3092\u3054\u53C2\u7167\u304F\u3060\u3055\u3044\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C2\u6761\u3000\u53D6\u5F97\u60C5\u5831'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1.\u5F53\u793E\u306F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u304A\u3044\u3066\u3001\u4EE5\u4E0B\u306B\u5B9A\u3081\u308B\u901A\u308A\u3001\u500B\u4EBA\u60C5\u5831\uFF08\u500B\u4EBA\u60C5\u5831\u4FDD\u8B77\u6CD5\u7B2C2\u6761\u7B2C1\u9805\u306B\u3088\u308A\u5B9A\u7FA9\u3055\u308C\u305F\u300C\u500B\u4EBA\u60C5\u5831\u300D\u3092\u3044\u3044\u3001\u4EE5\u4E0B\u540C\u69D8\u3068\u3057\u307E\u3059)\u3092\u542B\u3080\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u3092\u53D6\u5F97\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '(1)\u3054\u63D0\u4F9B\u3044\u305F\u3060\u304F\u60C5\u5831'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30A2\u3000\u57FA\u790E\u60C5\u5831\uFF1A\u643A\u5E2F\u96FB\u8A71\u756A\u53F7\uFF08SMS\u8A8D\u8A3C\uFF09\u3001Google\u30A2\u30AB\u30A6\u30F3\u30C8\u3001Facebook\u30A2\u30AB\u30A6\u30F3\u30C8\u7B49 \u5F53\u793E\u306F\u3001\u304A\u5BA2\u69D8\u304C\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u65B0\u898F\u767B\u9332\u3055\u308C\u308B\u969B\u306B\u3001\u304A\u5BA2\u69D8\u3092\u7279\u5B9A\u3001\u8B58\u5225\u3057\u5F97\u308B\u60C5\u5831\uFF08\u4EE5\u4E0B\u300C\u500B\u4EBA\u60C5\u5831\u300D\u3068\u3044\u3044\u307E\u3059\uFF09\u3092\u53CE\u96C6\u3057\u307E\u3059\u3002\u5177\u4F53\u7684\u306B\u306F\u3001'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30FB\u304A\u96FB\u8A71\u756A\u53F7\uFF08SMS\u8A8D\u8A3C\uFF09\u3067\u767B\u9332\u3057\u3066\u3044\u305F\u3060\u304F\u65B9\u6CD5\u306B\u95A2\u3057\u3066\u306F\u3001\u643A\u5E2F\u96FB\u8A71\u756A\u53F7\u3092\u53CE\u96C6\u3057\u307E\u3059\u3002 \u30FBGoogle\u3001Facebook\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u304A\u6301\u3061\u306E\u65B9\u306F\u3001\u3044\u305A\u308C\u304B\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u8A2D\u5B9A\u306B\u3088\u308A\u5F53\u793E\u304B\u3089\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u8A31\u5BB9\u3055\u308C\u308B\u30E6\u30FC\u30B6ID\u3092\u53CE\u96C6\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30A4\u3000\u305D\u306E\u4ED6\u767B\u9332\u60C5\u5831\uFF1A\u30CB\u30C3\u30AF\u30CD\u30FC\u30E0\u3001\u751F\u5E74\u6708\u65E5\u3001\u6027\u5225\u3001\u90FD\u9053\u5E9C\u770C\u3001\u3054\u8077\u696D\uFF08\u4EFB\u610F\uFF09 \u3001\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u5199\u771F\uFF08\u4EFB\u610F\uFF09\u305D\u306E\u4ED6\u306E\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u60C5\u5831\u3092\u30E6\u30FC\u30B6\u30FC\u3068\u3057\u3066\u3054\u767B\u9332\u3044\u305F\u3060\u304F\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '(2) \u672C\u30B5\u30FC\u30D3\u30B9\u3054\u5229\u7528\u6642\u306B\u5F53\u793E\u304C\u53CE\u96C6\u3059\u308B\u60C5\u5831'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30A2\u3000\u7AEF\u672B\u60C5\u5831'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u5F53\u793E\u306F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u7DAD\u6301\u53CA\u3073\u6539\u5584\u53C8\u306F\u4E0D\u6B63\u884C\u70BA\u9632\u6B62\u306E\u305F\u3081\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u4F7F\u7528\u3055\u308C\u308B\u7AEF\u672B\u56FA\u6709\u306E\u60C5\u5831\uFF08\u7AEF\u672B\u56FA\u6709\u306EID\u7B49\u306E\u500B\u4F53\u8B58\u5225\u60C5\u5831\u7B49\uFF09\u3092\u53CE\u96C6\u3059\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30A4\u3000\u30ED\u30B0\u60C5\u5831\u53CA\u3073\u884C\u52D5\u5C65\u6B74\u60C5\u5831'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u5F53\u793E\u306F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u7DAD\u6301\u53CA\u3073\u6539\u5584\u53C8\u306F\u4E0D\u6B63\u884C\u70BA\u9632\u6B62\u3092\u76EE\u7684\u3068\u3057\u3066\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u5229\u7528\u6642\u306B\u81EA\u52D5\u3067\u751F\u6210\u3001\u4FDD\u5B58\u3055\u308C\u308BIP\u30A2\u30C9\u30EC\u30B9\u3001\u30E6\u30FC\u30B6\u30FC\u304B\u3089\u306E\u30EA\u30AF\u30A8\u30B9\u30C8\u65E5\u6642\u3001\u30A2\u30D7\u30EA\u5185\u3067\u306E\u64CD\u4F5C\u5C65\u6B74\u60C5\u5831\u7B49\u3092\u53CE\u96C6\u3059\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30A6\u3000\u4F4D\u7F6E\u60C5\u5831'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u5F53\u793E\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u306E\u73FE\u5728\u4F4D\u7F6E\u7B49\u306E\u60C5\u5831\u3092\u5229\u7528\u3057\u305F\u30B5\u30FC\u30D3\u30B9\u3092\u63D0\u4F9B\u3059\u308B\u305F\u3081\u3001\u5F53\u8A72\u30B5\u30FC\u30D3\u30B9\u306E\u63D0\u4F9B\u306B\u5FC5\u8981\u306A\u7BC4\u56F2\u5185\u3067\u3001\u30E6\u30FC\u30B6\u30FC\u306E\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u7AEF\u672B\u3001\u30BF\u30D6\u30EC\u30C3\u30C8\u745E\u672B\u305D\u306E\u4ED6\u306E\u60C5\u5831\u7AEF\u672B\u7B49\u304B\u3089\u9001\u4FE1\u3055\u308C\u308B\u4F4D\u7F6E\u60C5\u5831\u3092\u53CE\u96C6\u3059\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u306A\u304A\u3001\u60C5\u5831\u7AEF\u672B\u4E0A\u306E\u8A2D\u5B9A\u306E\u5909\u66F4\u306B\u3088\u308A\u4F4D\u7F6E\u60C5\u5831\u306E\u9001\u4FE1\u3092\u505C\u6B62\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u304C\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u6A5F\u80FD\u306E\u4E00\u90E8\u3092\u5229\u7528\u51FA\u6765\u306A\u304F\u306A\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '2.\u5F53\u793E\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u53D6\u5F97\u306B\u3042\u305F\u308A\u3001\u865A\u507D\u305D\u306E\u4ED6\u4E0D\u6B63\u306E\u624B\u6BB5\u306B\u3088\u3089\u305A\u3001\u9069\u6B63\u306A\u65B9\u6CD5\u306B\u3088\u308A\u53D6\u5F97\u3057\u307E\u3059\u3002\u307E\u305F\u3001\u5F53\u793E\u306F\u30E6\u30FC\u30B6\u30FC\u304C\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u306B\u3088\u308B\u53D6\u5F97\u4EE5\u5916\u306E\u65B9\u6CD5\u3067\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u3092\u53D6\u5F97\u3059\u308B\u5834\u5408\u306B\u306F\u3001\u305D\u306E\u5229\u7528\u76EE\u7684\u3092\u4E8B\u524D\u306B\u901A\u77E5\u53C8\u306F\u516C\u8868\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C3\u6761\u3000\u5229\u7528\u76EE\u7684'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1.\u5F53\u793E\u306F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u3092\u901A\u3058\u3066\u53D6\u5F97\u3057\u305F\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u3092\u3001\u4E0B\u8A18\u306E\u76EE\u7684\u306E\u7BC4\u56F2\u5185\u3067\u9069\u6B63\u306B\u53D6\u308A\u6271\u3044\u307E\u3059\u3002\u30E6\u30FC\u30B6\u30FC\u3054\u672C\u4EBA\u306E\u540C\u610F\u306A\u304F\u5229\u7528\u76EE\u7684\u306E\u7BC4\u56F2\u3092\u8D85\u3048\u3066\u5229\u7528\u3059\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF08\uFF11\uFF09\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u63D0\u4F9B\u30FB\u7DAD\u6301\u30FB\u6539\u5584'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30FB\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u304A\u3051\u308B\u3054\u672C\u4EBA\u78BA\u8A8D\u53CA\u3073\u4E0D\u6B63\u5229\u7528\u9632\u6B62'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30FB\u4ED6\u30E6\u30FC\u30B6\u3078\u306E\u901A\u77E5\u3001\u901A\u4FE1\u305D\u306E\u4ED6\u306E\u30B3\u30DF\u30E5\u30CB\u30B1\u30FC\u30B7\u30E7\u30F3\u6A5F\u80FD\u3092\u542B\u3080\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5186\u6ED1\u306A\u63D0\u4F9B\u3001\u7DAD\u6301\u53CA\u3073\u6539\u5584'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30FB\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u95A2\u3059\u308B\u30E6\u30FC\u30B6\u30FC\u3078\u306E\u30A2\u30F3\u30B1\u30FC\u30C8\u7B49\u306E\u5B9F\u65BD'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF08\uFF12\uFF09\u30E6\u30FC\u30B6\u30FC\u3078\u306E\u901A\u77E5\u30FB\u5BFE\u5FDC'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30FB\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u95A2\u3059\u308B\u3054\u6848\u5185\u3001\u304A\u554F\u3044\u5408\u308F\u305B\u7B49\u3078\u306E\u5BFE\u5FDC'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30FB\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u95A2\u9023\u3059\u308B\u65B0\u305F\u306A\u30B5\u30FC\u30D3\u30B9\u306E\u901A\u77E5\u53C8\u306F\u63D0\u4F9B'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30FB\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u95A2\u3059\u308B\u5229\u7528\u898F\u7D04\u53C8\u306F\u672C\u30DD\u30EA\u30B7\u30FC\u306E\u5909\u66F4'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30FB\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u505C\u6B62\u30FB\u4E2D\u6B62\u30FB\u5951\u7D04\u89E3\u9664'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30FB\u305D\u306E\u4ED6\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u95A2\u3059\u308B\u91CD\u8981\u306A\u304A\u77E5\u3089\u305B\u7B49\u306E\u901A\u77E5'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF08\uFF13\uFF09\u7B2C\u4E09\u8005\u63D0\u4F9B'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u4E0B\u8A18\u306B\u8A18\u8F09\u306E\u60C5\u5831\u63D0\u4F9B\u3092\u53D7\u3051\u305F\u7B2C\u4E09\u8005\u306F\u3001\u5F53\u8A72\u60C5\u5831\u3092\u4EE5\u4E0B\u306E\u76EE\u7684\u306E\u70BA\u306B\u5229\u7528\u3057\u307E\u3059\u3002 \u30FB\u63D0\u643A\u30B5\u30FC\u30D3\u30B9\u306E\u63D0\u4F9B \u30FB\u30E6\u30FC\u30B6\u30FC\u30CB\u30FC\u30BA\u3084\u8208\u5473\u30FB\u95A2\u5FC3\u306B\u30DE\u30C3\u30C1\u3057\u305F\u5E83\u544A\u7B49\u306E\u8868\u793A \u30FB\u5E83\u544A\u52B9\u679C\u5206\u6790 \u30FB\u5E02\u5834\u8ABF\u67FB\u53CA\u3073\u5206\u6790'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '2.\u5F53\u793E\u306F\u3001\u524D\u9805\u306E\u5229\u7528\u76EE\u7684\u3092\u3001\u5909\u66F4\u524D\u306E\u5229\u7528\u76EE\u7684\u3068\u76F8\u5F53\u306E\u95A2\u9023\u6027\u3092\u6709\u3059\u308B\u3068\u5408\u7406\u7684\u306B\u8A8D\u3081\u3089\u308C\u308B\u7BC4\u56F2\u5185\u306B\u3066\u5909\u66F4\u3059\u308B\u3053\u3068\u304C\u3042\u308A\u3001\u5909\u66F4\u3057\u305F\u5834\u5408\u306B\u306F\u3001\u5F53\u793E\u304C\u5225\u9014\u5B9A\u3081\u308B\u65B9\u6CD5\u306B\u3088\u308A\u3001\u30E6\u30FC\u30B6\u30FC\u306B\u901A\u77E5\u53C8\u306F\u516C\u8868\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C4\u6761\u3000\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u306E\u7B2C\u4E09\u8005\u63D0\u4F9B'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1.\u5F53\u793E\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u306E\u3046\u3061\u3001\u500B\u4EBA\u60C5\u5831\u306B\u3064\u3044\u3066\u306F\u3001\u4EE5\u4E0B\u306E\u5834\u5408\u3092\u9664\u304D\u3001\u7B2C\u4E09\u8005\u306B\u63D0\u4F9B\u3059\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '(1)\u30E6\u30FC\u30B6\u30FC\u306E\u540C\u610F\u3092\u5F97\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '(2)\u6CD5\u4EE4\u306B\u57FA\u3065\u304F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '(3)\u672C\u30B5\u30FC\u30D3\u30B9\u5229\u7528\u4E0A\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u4ED6\u4EBA\u306E\u5229\u76CA\u3092\u5BB3\u3057\u82E5\u3057\u304F\u306F\u516C\u5E8F\u826F\u4FD7\u306B\u53CD\u3059\u308B\u884C\u70BA\u305D\u306E\u4ED6\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u898F\u7D04\u306B\u9054\u53CD\u3059\u308B\u884C\u70BA\u3092\u884C\u3044\u53C8\u306F\u3053\u308C\u3092\u884C\u304A\u3046\u3068\u3059\u308B\u3068\u304D\u306B\u3001\u5F53\u8A72\u884C\u70BA\u306B\u5BFE\u3057\u3066\u5FC5\u8981\u306A\u51E6\u7F6E\u3092\u53D6\u308B\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '(4)\u4EBA\u306E\u751F\u547D\u3001\u8EAB\u4F53\u53C8\u306F\u8CA1\u7523\u306E\u4FDD\u8B77\u306E\u305F\u3081\u306B\u5FC5\u8981\u304C\u3042\u308B\u5834\u5408\u3067\u3042\u308A\u3001\u672C\u4EBA\u306E\u540C\u610F\u3092\u5F97\u308B\u3053\u3068\u304C\u56F0\u96E3\u3067\u3042\u308B\u3068\u304D'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '(5)\u516C\u8846\u885B\u751F\u306E\u5411\u4E0A\u53C8\u306F\u5150\u7AE5\u306E\u5065\u5168\u306A\u80B2\u6210\u306E\u63A8\u9032\u306E\u305F\u3081\u306B\u7279\u306B\u5FC5\u8981\u304C\u3042\u308B\u5834\u5408\u3067\u3042\u3063\u3066\u3001\u672C\u4EBA\u306E\u540C\u610F\u3092\u5F97\u308B\u3053\u3068\u304C\u56F0\u96E3\u3067\u3042\u308B\u3068\u304D'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '(6)\u56FD\u306E\u6A5F\u95A2\u82E5\u3057\u304F\u306F\u5730\u65B9\u516C\u5171\u56E3\u4F53\u53C8\u306F\u305D\u306E\u59D4\u8A17\u3092\u53D7\u3051\u305F\u8005\u304C\u6CD5\u4EE4\u306E\u5B9A\u3081\u308B\u4E8B\u52D9\u3092\u9042\u884C\u3059\u308B\u3053\u3068\u306B\u5BFE\u3057\u3066\u5354\u529B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u5834\u5408\u3067\u3042\u3063\u3066\u3001\u672C\u4EBA\u306E\u540C\u610F\u3092\u5F97\u308B\u3053\u3068\u306B\u3088\u308A\u5F53\u8A72\u4E8B\u52D9\u306E\u9042\u884C\u306B\u652F\u969C\u3092\u53CA\u307C\u3059\u304A\u305D\u308C\u304C\u3042\u308B\u3068\u304D'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '(7)\u5408\u4F75\u3001\u4F1A\u793E\u5206\u5272\u3001\u4E8B\u696D\u8B72\u6E21\u305D\u306E\u4ED6\u306E\u4E8B\u7531\u306B\u3088\u308A\u30E6\u30FC\u30B6\u30FC\u306E\u500B\u4EBA\u60C5\u5831\u3092\u542B\u3080\u4E8B\u696D\u306E\u7D99\u627F\u304C\u306A\u3055\u308C\u308B\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '2.\u5F53\u793E\u306F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u3068\u63D0\u643A\u3059\u308B\u30B5\u30FC\u30D3\u30B9\uFF08\u4EE5\u4E0B\u300C\u63D0\u643A\u30B5\u30FC\u30D3\u30B9\u300D\u3068\u3044\u3044\u307E\u3059\uFF09\u3092\u63D0\u4F9B\u3059\u308B\u4E8B\u696D\u8005\uFF08\u4EE5\u4E0B\u300C\u63D0\u643A\u30D1\u30FC\u30C8\u30CA\u30FC\u300D\u3068\u3044\u3044\u307E\u3059\uFF09\u306B\u5BFE\u3057\u3001\u30E6\u30FC\u30B6\u30FC\u306B\u63D0\u643A\u30B5\u30FC\u30D3\u30B9\u3092\u63D0\u4F9B\u3059\u308B\u305F\u3081\u3001\u30E6\u30FC\u30B6\u30FC\u306E\u540C\u610F\u3092\u5F97\u305F\u4E0A\u3067\u500B\u4EBA\u60C5\u5831\u3092\u542B\u3080\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u3092\u63D0\u4F9B\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C5\u6761\xA0\u304A\u5B50\u69D8\u306E\u500B\u4EBA\u60C5\u5831\u306B\u3064\u3044\u3066'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u6E8015\u6B73\u672A\u6E80\u306E\u304A\u5BA2\u69D8\u304C\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3057\u3001\u500B\u4EBA\u60C5\u5831\u3092\u5165\u529B\u3055\u308C\u308B\u5834\u5408\u306B\u306F\u3001\u4FDD\u8B77\u8005\u306E\u65B9\u306E\u540C\u610F\u304C\u5FC5\u8981\u3068\u306A\u308A\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C6\u6761\u3000\u500B\u4EBA\u60C5\u5831\u306E\u53D6\u6271\u3044\u306E\u59D4\u8A17'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u5F53\u793E\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u304B\u3089\u53D6\u5F97\u3057\u305F\u500B\u4EBA\u60C5\u5831\u306E\u5168\u90E8\u53C8\u306F\u4E00\u90E8\u306E\u53D6\u6271\u3044\u3092\u7B2C\u4E09\u8005\u306B\u59D4\u8A17\uFF08\u500B\u4EBA\u60C5\u5831\u3092\u542B\u3080\u60C5\u5831\u306E\u7BA1\u7406\u3092\u4E8B\u696D\u8005\u306B\u59D4\u8A17\u3059\u308B\u5834\u5408\u306A\u3069\u3092\u3044\u3044\u307E\u3059\uFF09\u3059\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u5834\u5408\u3001\u5F53\u793E\u306F\u3001\u5F53\u8A72\u59D4\u8A17\u5148\u3068\u306E\u9593\u3067\u672C\u30DD\u30EA\u30B7\u30FC\u306B\u6E96\u3058\u308B\u5185\u5BB9\u306E\u79D8\u5BC6\u4FDD\u6301\u5951\u7D04\u7B49\u3092\u3042\u3089\u304B\u3058\u3081\u7DE0\u7D50\u3059\u308B\u3068\u3068\u3082\u306B\u3001\u5F53\u8A72\u59D4\u8A17\u5148\u306B\u304A\u3044\u3066\u60C5\u5831\u306E\u9069\u5207\u306A\u5B89\u5168\u7BA1\u7406\u304C\u56F3\u3089\u308C\u308B\u3088\u3046\u3001\u5FC5\u8981\u304B\u3064\u9069\u5207\u306A\u76E3\u7763\u3092\u884C\u3044\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C7\u6761\u3000\u5171\u540C\u5229\u7528'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u5F53\u793E\u306F\u3001\u63D0\u643A\u30D1\u30FC\u30C8\u30CA\u30FC\u3068\u306E\u9593\u3067\u3001\u63D0\u643A\u30B5\u30FC\u30D3\u30B9\u306E\u63D0\u4F9B\u306B\u5FC5\u8981\u306A\u7BC4\u56F2\u306B\u304A\u3044\u3066\u3001\u30E6\u30FC\u30B6\u30FC\u306E\u500B\u4EBA\u60C5\u5831\u3092\u5171\u540C\u3067\u5229\u7528\u3059\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u5834\u5408\u5F53\u793E\u306F\u3042\u3089\u304B\u3058\u3081\u3001\u63D0\u643A\u30D1\u30FC\u30C8\u30CA\u30FC\u306E\u540D\u79F0\u3001\u5171\u540C\u5229\u7528\u76EE\u7684\u3001\u5171\u540C\u5229\u7528\u3059\u308B\u60C5\u5831\u306E\u7A2E\u985E\u3092\u516C\u8868\u3059\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C8\u6761\u3000\u5B89\u5168\u7BA1\u7406\u4F53\u5236'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1.\u5F53\u793E\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u306E\u6F0F\u6D29\u3001\u6EC5\u5931\u53C8\u306F\u6BC0\u640D\u306E\u9632\u6B62\u305D\u306E\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u306E\u4FDD\u8B77\u306E\u305F\u3081\u3001 \u500B\u4EBA\u60C5\u5831\u30D5\u30A1\u30A4\u30EB\u30D8\u306E\u30A2\u30AF\u30BB\u30B9\u5236\u9650\u306E\u5B9F\u65BD\u3001\u30A2\u30AF\u30BB\u30B9\u30ED\u30B0\u306E\u8A18\u9332\u3001\u307E\u305F\u5916\u90E8\u304B\u3089\u306E\u4E0D\u6B63\u30A2\u30AF\u30BB\u30B9\u9632\u6B62\u306E\u305F\u3081\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30BD\u30D5\u30C8\u306E\u5C0E\u5165\u7B49\u3001\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u306E\u5B89\u5168\u7BA1\u7406\u306E\u305F\u3081\u306B\u5FC5\u8981\u304B\u3064\u9069\u5207\u306A\u63AA\u7F6E\u3092\u8B1B\u3058\u3066\u3044\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '2.\u5F53\u793E\u306F\u3001\u4EE3\u8868\u53D6\u7DE0\u5F79\u3092\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u7BA1\u7406\u8CAC\u4EFB\u8005\u3068\u3057\u3001\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u306E\u9069\u6B63\u306A\u7BA1\u7406\u53CA\u3073\u7D99\u7D9A\u7684\u306A\u6539\u5584\u3092\u5B9F\u65BD\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C9\u6761\u3000\u30E6\u30FC\u30B6\u30FC\u306E\u60C5\u5831\u958B\u793A\u30FB\u8A02\u6B63\u7B49\u306E\u6A29\u5229'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1.\u30E6\u30FC\u30B6\u30FC\u306F\u5F53\u793E\u306B\u63D0\u4F9B\u3057\u305F\u500B\u4EBA\u60C5\u5831\u306B\u3064\u3044\u3066\u3001\u4EE5\u4E0B\u306B\u5B9A\u3081\u308B\u624B\u7D9A\u304D\u306B\u5F93\u3044\u3001\u958B\u793A\u3092\u8ACB\u6C42\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '(1)\u5F53\u793E\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u4E0A\u306E\u6240\u5B9A\u306E\u30D5\u30A9\u30FC\u30E0\u306B\u5165\u529B\u3057\u9001\u4FE1\u3059\u308B\u65B9\u6CD5\u3001\u53C8\u306F\u7533\u8ACB\u66F8\u306B\u672C\u4EBA\u78BA\u8A8D\uFF08\u4EE3\u7406\u4EBA\u306B\u3088\u308B\u7533\u8ACB\u306E\u5834\u5408\u3001\u9069\u6B63\u306A\u4EE3\u7406\u4EBA\u3067\u3042\u308B\u3053\u3068\u306E\u78BA\u8A8D\uFF09\u306E\u305F\u3081\u306B\u5FC5\u8981\u306A\u66F8\u985E\u3092\u540C\u5C01\u306E\u3046\u3048\u3001\u90F5\u9001\u3059\u308B\u65B9\u6CD5\u306B\u3088\u308A\u3054\u8ACB\u6C42\u304F\u3060\u3055\u3044\u3002\u66F8\u9762\u306B\u3088\u308B\u7533\u8ACB\u306E\u5834\u5408\u306F\u30011\u56DE\u306E\u7533\u8ACB\u306B\u3064\u304D\u624B\u6570\u65991,000\u5186\u3092\u7533\u3057\u53D7\u3051\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '(2)\u524D\u53F7\u306B\u57FA\u3065\u304F\u7533\u51FA\u306B\u3064\u304D\u672C\u4EBA\u78BA\u8A8D\u304C\u306A\u3055\u308C\u305F\u3068\u304D\u306F\u3001\u5F53\u793E\u306F\u3001\u5408\u7406\u7684\u306A\u7BC4\u56F2\u3067\u500B\u4EBA\u60C5\u5831\u306E\u958B\u793A\u3092\u5B9F\u65BD\u3057\u307E\u3059\u3002\u305F\u3060\u3057\u3001\u500B\u4EBA\u60C5\u5831\u4FDD\u8B72\u6CD5\u305D\u306E\u4ED6\u306E\u6CD5\u4EE4\u306B\u3088\u308A\u5F53\u793E\u304C\u958B\u793A\u7FA9\u52D9\u3092\u8CA0\u308F\u306A\u3044\u5834\u5408\u53C8\u306F\u6B63\u5F53\u306A\u7406\u7531\u306A\u304F\u540C\u5185\u5BB9\u306E\u8ACB\u6C42\u304C\u4F55\u5EA6\u3082\u7E70\u308A\u8FD4\u3055\u308C\u308B\u5834\u5408\u306F\u3001\u3053\u306E\u9650\u308A\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '2.\u5F53\u793E\u306E\u4FDD\u6709\u3059\u308B\u30E6\u30FC\u30B6\u30FC\u306B\u95A2\u3059\u308B\u500B\u4EBA\u60C5\u5831\u306E\u5185\u5BB9\u304C\u4E8B\u5B9F\u3068\u7570\u306A\u308B\u5834\u5408\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u4EE5\u4E0B\u306B\u5B9A\u3081\u308B\u624B\u7D9A\u306B\u5F93\u3044\u3001\u8A02\u6B63\u3001\u8FFD\u52A0\u3001\u524A\u9664\u3092\u8ACB\u6C42\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\xA0(1)\u5F53\u793E\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u4E0A\u306E\u6240\u5B9A\u306E\u30D5\u30A9\u30FC\u30E0\u306B\u5165\u529B\u3057\u9001\u4FE1\u3059\u308B\u65B9\u6CD5\u3001\u53C8\u306F\u7533\u8ACB\u66F8\u306B\u672C\u4EBA\u78BA\u8A8D\uFF08\u4EE3\u7406\u4EBA\u306B\u3088\u308B\u7533\u8ACB\u306E\u5834\u5408\u3001\u9069\u6B63\u306A\u4EE3\u7406\u4EBA\u3067\u3042\u308B\u3053\u3068\u306E\u78BA\u8A8D\uFF09\u306E\u305F\u3081\u306B\u5FC5\u8981\u306A\u66F8\u985E\u3092\u540C\u5C01\u306E\u3046\u3048\u3001\u90F5\u9001\u306B\u3088\u308A\u3054\u8ACB\u6C42\u304F\u3060\u3055\u3044\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\xA0(2)\u524D\u53F7\u306B\u57FA\u3065\u304F\u7533\u51FA\u306B\u3064\u304D\u672C\u4EBA\u78BA\u8A8D\u304C\u306A\u3055\u308C\u305F\u3068\u304D\u306F\u3001\u5F53\u793E\u306F\u3001\u5408\u7406\u7684\u306A\u7BC4\u56F2\u3067\u9045\u6EDE\u306A\u304F\u8ABF\u67FB\u3092\u884C\u3044\u3001\u305D\u306E\u7D50\u679C\u306B\u57FA\u3065\u304D\u500B\u4EBA\u60C5\u5831\u306E\u8A02\u6B63\u3001\u8FFD\u52A0\u3001\u524A\u9664\u3092\u3057\u307E\u3059\u3002\u305F\u3060\u3057\u3001\u500B\u4EBA\u60C5\u5831\u4FDD\u8B77\u6CD5\u305D\u306E\u4ED6\u306E\u6CD5\u4EE4\u306B\u3088\u308A\u5F53\u793E\u304C\u3053\u308C\u3089\u306E\u7FA9\u52D9\u3092\u8CA0\u308F\u306A\u3044\u5834\u53F0\u3001\u6B63\u5F53\u306A\u7406\u7531\u306A\u304F\u540C\u5185\u5BB9\u306E\u8ACB\u6C42\u304C\u4F55\u5EA6\u3082\u7E70\u308A\u8FD4\u3055\u308C\u308B\u5834\u5408\u3001\u53C8\u306F\u904E\u5EA6\u306A\u6280\u8853\u7684\u4F5C\u696D\u3092\u8981\u3059\u308B\u5834\u5408\u306F\u3053\u306E\u9650\u308A\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C10\u6761\u3000\u672C\u30DD\u30EA\u30B7\u30FC\u306E\u5909\u66F4'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1.\u5F53\u793E\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u306E\u53D6\u6271\u3044\u306B\u95A2\u3059\u308B\u904B\u7528\u72B6\u6CC1\u3092\u9069\u5B9C\u898B\u76F4\u3057\u3001\u7D99\u7D71\u7684\u306A\u6539\u5584\u306B\u52AA\u3081\u308B\u3082\u306E\u3068\u3057\u3001\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u3001\u968F\u6642\u672C\u30DD\u30EA\u30B7\u30FC\u3092\u5909\u66F4\u3059\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '2.\u5909\u66F4\u5F8C\u306E\u672C\u30DD\u30EA\u30B7\u30FC\u306B\u3064\u3044\u3066\u306F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u4E0A\u53C8\u306F\u5F53\u793E\u306E\u904B\u55B6\u3059\u308B\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u3067\u306E\u63B2\u793A\u305D\u306E\u4ED6\u306E\u5206\u304B\u308A\u3084\u3059\u3044\u65B9\u6CD5\u306B\u3088\u308A\u544A\u77E5\u3057\u307E\u3059\u3002\u305F\u3060\u3057\u3001\u6CD5\u4EE4\u4E0A\u30E6\u30FC\u30B6\u30FC\u306E\u540C\u610F\u304C\u5FC5\u8981\u3068\u306A\u308B\u3088\u3046\u306A\u5185\u5BB9\u306E\u5909\u66F4\u3092\u884C\u3046\u3068\u304D\u306F\u3001\u5225\u9014\u5F53\u793E\u304C\u5B9A\u3081\u308B\u65B9\u6CD5\u306B\u3088\u308A\u3001\u30E6\u30FC\u30B6\u30FC\u306E\u540C\u610F\u3092\u53D6\u5F97\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C11\u6761\u3000\u53D6\u5F97\u60C5\u5831\u306E\u7834\u68C4'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u53D6\u5F97\u3057\u305F\u30E6\u30FC\u30B6\u30FC\u306E\u500B\u4EBA\u60C5\u5831\u306F\u3001\u5F53\u793E\u306B\u3088\u308B\u901A\u5E38\u306E\u4E8B\u696D\u904B\u55B6\u306B\u7167\u3089\u3057\u3066\u3001\u5408\u7406\u7684\u306B\u4E0D\u8981\u3068\u5224\u65AD\u3055\u308C\u308B\u6642\u70B9\u3067\u7834\u68C4\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C12\u6761\u3000\u304A\u554F\u3044\u5408\u308F\u305B'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u5F53\u793E\u306E\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u306E\u53D6\u6271\u3044\u306B\u95A2\u3059\u308B\u3054\u610F\u898B\u3001\u3054\u8CEA\u554F\u3001\u82E6\u60C5\u306E\u304A\u7533\u3057\u51FA\u3001\u305D\u306E\u4ED6\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u306E\u53D6\u6271\u3044\u306B\u95A2\u3059\u308B\u304A\u554F\u3044\u5408\u308F\u305B\u306F\u3001\u4E0B\u8A18\u7A93\u53E3\u307E\u3067\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u682A\u5F0F\u4F1A\u793E abasaku'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u3012107-0062 \u6771\u4EAC\u90FD\u6E2F\u533A\u5357\u9752\u5C711-15-18 \u30EA\u30FC\u30E9\u4E43\u6728\u5742 701'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'support@flickontv.jp'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '2016\u5E7410\u670821\u65E5\u5236\u5B9A'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\xA9 2018 abasaku Inc.'
	      )
	    )
	  );
	};
	exports.default = Privacy;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-js-4bb56602f1216ee7d934.js